import { Matcher } from 'utils/adl-services';

// Visibility submenu levels (Question / Answer / Method / Group).
export const VISIBILITY_LEVEL = {
  QUESTION: 'question',
  GROUP: 'group',
  METHOD: 'method',
  ANSWER: 'answer',
};

// UI-only matcher keys for Visibility. Node level stores a single question/
// group/method refId with Includes/NotIncludes; answer level stores an array
// of answer/row/column refIds with IncludesAll/NotIncludesAll.
export const VISIBILITY_MATCHER = {
  IS_DISPLAYED: `${Matcher.Includes}_is_displayed`,
  IS_NOT_DISPLAYED: `${Matcher.NotIncludes}_is_not_displayed`,
};

// Floor width so "Is not visible" fits next to the chevron.
export const VISIBILITY_MATCHER_MIN_WIDTH = 115;

export const basicOptions = [
  {
    value: Matcher.Equal,
    key: Matcher.Equal,
  },
  {
    value: Matcher.NotEqual,
    key: Matcher.NotEqual,
  },
];

export const numericOptions = [
  {
    value: Matcher.GreaterThan,
    key: Matcher.GreaterThan,
  },
  {
    value: Matcher.GreaterThanEqual,
    key: Matcher.GreaterThanEqual,
  },
  {
    value: Matcher.LowerThan,
    key: Matcher.LowerThan,
  },
  {
    value: Matcher.LowerThanEqual,
    key: Matcher.LowerThanEqual,
  },
  ...basicOptions,
];

export const onlyContainsOption = {
  value: Matcher.Contains,
  key: Matcher.Contains,
};

export const containsOptions = [
  {
    value: Matcher.Contains,
    key: Matcher.Contains,
  },
  {
    value: Matcher.NotContains,
    key: Matcher.NotContains,
  },
];

export const equalsOption = {
  value: Matcher.Equal,
  key: Matcher.Equal,
};

export const containsWordOption = {
  value: Matcher.ContainsWord,
  key: Matcher.ContainsWord,
};

export const nullOptions = [
  {
    value: Matcher.IsNull,
    key: Matcher.IsNull,
  },
  {
    value: Matcher.IsNotNull,
    key: Matcher.IsNotNull,
  },
];

export const includesOptions = [
  {
    value: Matcher.Includes,
    key: Matcher.Includes,
  },
  {
    value: Matcher.IncludesOnly,
    key: Matcher.IncludesOnly,
  },
  {
    value: Matcher.NotIncludes,
    key: Matcher.NotIncludes,
  },
];
